import React from "react";
import { _universal_logger_v2 } from "../Helper/commonFunctions_v2";

export default class App extends React.Component {
    state = {
        reloadDone: false,
    };

    componentDidMount() {
        let { error } = this.props,
            current_time = new Date().getTime();
        const chunkFailedMessage = /Loading chunk [\d]+ failed/,
            cssFailedMessage = /Loading CSS chunk [\d]+ failed/;
        if (error?.message && (chunkFailedMessage.test(error.message) || cssFailedMessage.test(error.message))) {
            _universal_logger_v2({
                eventName: "js_error",
                entity_name: "",
                entity_id: "",
                page: "error_boundary",
                type: "js_error",
                error: error?.message ? error?.message : "",
                element: "",
                scroll_depth: "",
                passedThis: this,
                businessDataObj: {},
            });
            if (window.last_reload && window.last_reload - current_time < 20 * 1000) {
                // Reload was triggered in the last 20 secs and so will not be triggered again
            } else {
                window.last_reload = new Date().getTime();
                this.setState({ reloadDone: true }, () => {
                    navigator?.onLine && window.location.reload();
                    !navigator?.onLine && (window.location.href = "/");
                });
            }
        }
    }

    render() {
        let { error } = this.props,
            { reloadDone } = this.state;
        return (
            <div className="pA mxw400 wp80 h64 p8 mA l0 r0 bm0 t0 bdE lh24 taC br4 bsCard2" style={{ height: "min-content" }}>
                {/* {reloadDone && <div>Reloading....</div>} */}
                {reloadDone ? <p className="p16 fs16">Fetching Updates ...</p> : <p>Something went wrong !</p>}
                {!reloadDone && (
                    <>
                        <pre className="mxh360 oA wbBa wsR">{error?.message}</pre>
                        <div className="dF aiC jcC">
                            <a className="cF fw500 bdE p8 bgGm br4 dB m8 ttC ls1 tdN" href="/dashboard">
                                Go To Dashboard
                            </a>
                            <div
                                className="cF fw500 bdE p8 bgGm br4 dB m8 ttC ls1 tdN cuP"
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                Reload
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}
